import SplitInput from './SplitInput';
import { Fragment } from 'preact';
import { styled } from 'goober';

const SplitInputContainer = styled('div')`
  .singleInputContainer {
    display: flex;
    align-items: center;
    margin: 15px 0;
  }
  .singleInput input {
    width: 60px;
    height: 60px;
    font-size: 18px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid #d3d8e6;
    margin-right: 4px;
  }
  .singleInput input:focus {
    outline: none;
    border: 1px solid #1a73e8;
  }
`;

const CustomSplitInput = (props) => {
  const {
    onChange,
    isInputNum,
    onInfoIconClick,
    numInputs,
    value,
    withInfoIcon,
    containerStyle,
    className,
    shouldAutoFocus,
  } = props;
  return (
    <SplitInputContainer>
      <SplitInput
        {...props}
        numInputs={numInputs}
        isInputNum={isInputNum}
        onChange={onChange}
        className={`${className ? className : ''} singleInput`}
        containerStyle={`singleInputContainer ${
          containerStyle ? containerStyle : ''
        }`}
        value={value}
        separator={<Fragment>&nbsp;</Fragment>}
        withInfoIcon={withInfoIcon}
        onInfoIconClick={onInfoIconClick}
        shouldAutoFocus={shouldAutoFocus}
      />
    </SplitInputContainer>
  );
};
export default CustomSplitInput;



// WEBPACK FOOTER //
// ./components/checkoutWidget/CustomSplitInput.js